import React, { useEffect } from 'react';
import { useTranslate, Resource } from 'react-admin';

const CWResource = props => {
	const translate = useTranslate();
	useEffect(() => {
		document.title = translate(`resources.${props.name}.name`);
	}, [props.name, translate]);
	return <Resource {...props} />;
};

export default CWResource;
